module.exports = __webpack_public_path__ + "img/mergdata_mob_1.d925635f.png";